@if (config) {
  <header class="form__header">
    <h4 class="form__title">{{ config.form.title }}</h4>
    @if (config.form.description) {
      <p class="form__description">
        {{ config.form.description }}
      </p>
    }
  </header>
}

@if (config) {
  <form-group
    class="form__controls"
    [form]="form"
    [configs]="config.form.controls"
    direction="filter"
    (linkClicked)="handleLinkClick($event)"
    (keyup.enter)="submitLoginForm()"
  >
  </form-group>
}

@if (config) {
  <footer class="form__footer">
    <form-group
      [form]="rememberUser"
      [configs]="config.remember_user.controls"
      direction="filter"
    >
    </form-group>
    <a class="form__link" [routerLink]="'/auth/registration'">
      {{ config.registration_link_label }}
    </a>
    <div class="form__row">
      <zip-button
        [config]="config.submit"
        (zipButtonClicked)="submitLoginForm()"
      >
      </zip-button>
    </div>
  </footer>
}
